import { render } from "./VisionOneTable.vue?vue&type=template&id=393e8f6e"
import script from "./VisionOneTable.vue?vue&type=script&lang=js"
export * from "./VisionOneTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__